import { IconChevronLeft } from '@tabler/icons-react';
import NSIcon from 'bricks/NSIcon/NSIcon';
import React from 'react';
import { NSInput } from 'bricks';
import { NSInfoBanner } from 'components/NSInfoBanner/NSInfoBanner';
import { NSButtonBase } from 'bricks/NSButton/NSButton';
import { ISignUpManager } from '../../useSignUpManager';
import { IValidateSignupResponse } from '../../hooks/useValidateSignup';
import { TermsAndConditionsBlock } from '../../../../../components/signup/TermsAndConditionsBlock';

interface ManualSignUpSectionProps {
  onBack: () => void;
  signUpManager: ISignUpManager;
  userOrgLookupData?: IValidateSignupResponse;
  onSignUpSuccess?: (email: string) => void;
}

const ManualSignUpSection: React.FC<ManualSignUpSectionProps> = ({
    onBack, signUpManager, userOrgLookupData, onSignUpSuccess,
}) => {
    const {
        signUpEnabled,
        email,
        jobTitle,
        organizationName,
        name,
        validCaptcha,
        handleJobTitleChange,
        handleOrganizationNameChange,
        handleNameChange,
        handleSignUp,
    } = signUpManager;

    const handleSignUpClick = () => {
        handleSignUp();
        if (onSignUpSuccess) {
            onSignUpSuccess(email.value);
        }
    };

    return (
        <>
            <button
                type="button"
                className="DirectSignUp__SwitchPhaseButton heap-deal-signup-direct-different-method"
                onClick={onBack}
                data-testid="backButton"
            >
                <NSIcon icon={IconChevronLeft} className="mr-1" />
                {' '}
                Sign up with different method
            </button>
            <div className="DirectSignUp__FormFields">
                <div className="DirectSignUp__InputWrapper">
                    <label htmlFor="name" className="DirectSignUp__SectionLabel">Your information</label>
                    <NSInput
                        id="name"
                        name="name"
                        type="text"
                        placeholder="Enter name"
                        value={name.value}
                        onChange={handleNameChange}
                        className="DirectSignUp__Input"
                        autoComplete="name"
                    />
                </div>
                <div className="DirectSignUp__InputRow">
                    <NSInput
                        name="jobTitle"
                        type="text"
                        placeholder="Job title"
                        value={jobTitle.value}
                        onChange={handleJobTitleChange}
                        className="DirectSignUp__Input"
                        autoComplete="job-title"
                    />
                </div>
                {!userOrgLookupData?.org && (
                    <NSInput
                        id="organizationName"
                        name="organizationName"
                        type="text"
                        placeholder="Organization name"
                        value={organizationName.value}
                        onChange={handleOrganizationNameChange}
                        className="DirectSignUp__Input"
                        autoComplete="organization"
                        invalid={!!organizationName.errorMsg}
                        showErrorMsg={!!organizationName.errorMsg}
                        errorMsg={organizationName.errorMsg}
                    />
                )}
                <TermsAndConditionsBlock />
            </div>
            { !validCaptcha && (
                <NSInfoBanner title="Whoops! Seems you are not Human!" warning className="DirectSignUp__InvalidCaptcha" />
            )}
            <div className="DirectSignUp__FormSubmit">
                <NSButtonBase
                    color="primary"
                    callback={handleSignUpClick}
                    className="DirectSignUp__Button heap-deal-signup-direct-sign-up"
                    disabled={!signUpEnabled}
                    dataTestId="signUpButton"
                >
                    Sign up
                </NSButtonBase>
            </div>
        </>
    );
};

export default ManualSignUpSection;
